<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <TabNav :links="routesNav" />
    </div>

    <div class="container-body">
        <div class="info-grid">

            <section class="info-card">
                <h3 class="info-card__title">Información general</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>Nombre</dt>
                        <dd>{{ group.name || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Descripción</dt>
                        <dd>{{ group.desc || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Fecha creación</dt>
                        <dd>{{ dateTimeFormatter(group.created_at) }}</dd>
                    </div>
                </dl>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">
                    Usuarios del grupo
                    <span v-if="users.length" class="maps-count">{{ users.length }}</span>
                </h3>
                <!-- users es un arreglo: preguntar por !users nunca daba verdadero y la
                     sección quedaba vacía sin explicar por qué -->
                <p v-if="!users.length" class="maps-empty">Sin usuarios en este grupo</p>
                <ul v-else class="maps-list">
                    <li v-for="item in users" :key="item.id">
                        <router-link class="maps-list__item" :to="'/usuarios/' + item.id">
                            <font-awesome-icon icon="users" class="maps-list__icon"></font-awesome-icon>
                            <span class="maps-list__name">{{ item.firstname + ' ' + item.lastname }}</span>
                            <span class="maps-list__via">{{ item.username }}</span>
                            <span class="maps-list__go" aria-hidden="true">›</span>
                        </router-link>
                    </li>
                </ul>

                <Pagination
                v-show="totalPages!=0"
                v-bind:totalPages="totalPages"
                v-bind:currentPage="currentPage"
                v-bind:pageSize="pageSize"
                v-on:pagechanged="pageChangedClick"
                >
                </Pagination>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">
                    Mapas asignados al grupo
                    <span v-if="maps.length" class="maps-count">{{ maps.length }}</span>
                </h3>
                <p v-if="!maps.length" class="maps-empty">Sin mapas asignados</p>
                <ul v-else class="maps-list">
                    <li v-for="item in maps" :key="item.id">
                        <router-link class="maps-list__item" :to="'/mapas/' + item.id">
                            <font-awesome-icon icon="map" class="maps-list__icon"></font-awesome-icon>
                            <span class="maps-list__name">{{ item.name }}</span>
                            <span class="maps-list__go" aria-hidden="true">›</span>
                        </router-link>
                    </li>
                </ul>
            </section>

        </div>
    </div>

</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {pagination} from '@/components/mixin/pagination.js'
import {restGroup} from '@/components/mixin/restGroup.js'

export default{
    name: 'test',
    mixins: [formatter, pagination, restGroup],
    data(){
        return{
            users: [],
            maps: []
        }
    },
    components:{
        Breadcrumb,
        Pagination,
        TabNav
    },
    computed: {
        routesNav: function(){
          var links = [
                {name:'Editar grupo' , path: '/usuarios/grupos-de-usuarios/' + this.$route.params.idGroup + '/editar-grupo'},
                {name:'Historial de cambios' , path: '/usuarios/grupos-de-usuarios/' + this.$route.params.idGroup + '/historial-de-cambios'},
                {name:'Eliminar grupo' , path: '/usuarios/grupos-de-usuarios/' + this.$route.params.idGroup + '/eliminar-grupo'}
              ]
          //Asignar mapas requiere el permiso de mapas (los endpoints de la relación viven en ese bloque)
          if (this.$store.getters.getPermissions.maps) {
              links.splice(1, 0, {name:'Asignar mapas' , path: '/usuarios/grupos-de-usuarios/' + this.$route.params.idGroup + '/asignar-mapas'});
          }
          return links
        },
        routesBread: function(){
          return [
                {name: 'Usuarios', path: '/usuarios'},
                {name: 'Grupos', path: '/usuarios/grupos-de-usuarios/'},
                {name: this.group.name},
          ]
        }
    },
    props: [],
    methods:{
        pageChangedClick: function (page){
            this.currentPage = page;
            this.getGroupAllUsers(this.currentPage);
        },
        getGroupAllUsers: function(page){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/groups/' + this.$route.params.idGroup + '/users?page=' + page) //Paginación
            .then(function (response) {
                that.users = response.data || [];
                response.headers.totalpages == undefined ? that.totalPages = 0 : that.totalPages = parseInt(response.headers.totalpages, 10);
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getGroupAllMaps: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/groups/' + this.$route.params.idGroup + '/maps')
            .then(function (response) {
                that.maps = response.data || [];
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
    },
    updated () {

    },
    created () {
        //Verificar permisos
        this.$store.getters.getPermissions.users? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getGroup();
        this.getGroupAllUsers(this.currentPage);
        this.getGroupAllMaps();
    }
}
</script>

<style lang="scss" scoped>
// Los estilos del sistema info-card/maps-list viven en assets/style/style.scss
</style>
